import Footer from "../constant-screens/footer";
import Header from "../constant-screens/header";
import Navbar from "../constant-screens/navbar";
import FAQScreenBody from "../half-screens/faqScreenBody";

function FAQScreen() {
 return(
  <div>
   <Header />
   <Navbar />
   <FAQScreenBody />
   <Footer />
  </div>
 );
}

export default FAQScreen;